<template>
  <div class="app-wrapper">
    <el-container style="overflow-x: hidden">
      <el-header class="header">
        <!-- <div class="back"></div> -->
        <!-- <div class="text">Welcome to ...</div> -->
        <!-- <img src="@/assets/logo1.svg" alt="" /> -->
        <svg-icon
          data_iconName="logo1"
          className="logo1_icon"
          class="svgIcon"
          style="width: 270px; height: 80px"
        />
        <navbar
          @isCollapseFunction="isCollapseFunction"
          :isCollapse="isCollapse"
          :color="change ? 'rgb(15 15 15)' : '#f8f3f3'"
        />
      </el-header>
      <el-main class="elmain">
        <Breadcrumb />
        <!-- <Title /> -->
        <app-main />
        <!--  -->
      </el-main>
      <el-footer class="footer">
        <div>
          © 2020-2024
          <a href="" target="_blank">Cucumber Breeding Group</a> |
          <a href="https://ivf.caas.cn/index.htm" target="_blank">IVF</a>
          |
          <a href="http://www.caas.cn/" target="_blank">CAAS</a>
          <br />All Rights Reserved.&nbsp;&nbsp;津ICP备2021006605号-6
        </div>
        <div>
          <!-- <iframe
            style="background: transparent !important"
            scrolling="no"
            frameborder="0"
            allowtransparency="false"
            width="auto"
            src="map.html"
            id="iframe1"
          ></iframe> -->
          <a href="http://s01.flagcounter.com/more/DXLk" class="map"
            ><img
              src="https://s01.flagcounter.com/mini/DXLk/bg_637e8e/txt_FFFFFF/border_637e8e/flags_0/"
              alt="Flag Counter"
              border="0"
              class="map-img"
          /></a>
          <div id="map"></div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import Title from "@/components/title/index";
  import { Navbar, Sidebar, AppMain /* TagsView */ } from "./components";
  var rateChart;
  export default {
    name: "layout",
    props: {
      //传值
    },
    data() {
      return {
        isCollapse: false,
        top: 1,
        year: "",
        back: "浅色",
        change: false,
      };
    },
    components: {
      //引入模块
      Navbar,
      Sidebar,
      AppMain,
      Title,
      /* TagsView */
    },
    watch: {
      // watch擅长处理的场景：一个数据影响多个数据
    },
    computed: {
      // computed擅长处理的场景：一个数据受多个数据影响
    },
    mounted: function () {
      // 编译好的HTML挂载到页面完成后执行的事件钩子
      // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
      // 此钩子函数中一般会做一些ajax请求获取数据进行数据初始化
      console.log("Home");
      window.addEventListener("scroll", this.handleScroll, true);
      var year = this.getDateTime("year");
      this.year = year;
      this.getMap();
    },
    methods: {
      // 组件的方法

      ChangeColor(e) {
        // console.log(e,'layout')
        // this.back=e
        this.change = e;
      },
      isCollapseFunction(boolean) {
        this.isCollapse = boolean;
      },
      /*  handleScroll(e) {
      var top = e.target.scrollTop;
      this.top = top;
    }, */
      getDateTime(type) {
        var date = new Date();
        var hengGang = "-";
        var maoHao = ":";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var curDate = date.getDate();
        var curHours = date.getHours();
        var curMinutes = date.getMinutes();
        var curSeconds = date.getSeconds();

        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (curDate >= 0 && curDate <= 9) {
          curDate = "0" + curDate;
        }
        if (curHours >= 0 && curHours <= 9) {
          curHours = "0" + curHours;
        }
        if (curMinutes >= 0 && curMinutes <= 9) {
          curMinutes = "0" + curMinutes;
        }
        if (curSeconds >= 0 && curSeconds <= 9) {
          curSeconds = "0" + curSeconds;
        }
        var currentdate = "";
        if (type == "year") {
          currentdate = year;
          return currentdate;
        } else if (type == "month") {
          currentdate = year + hengGang + month;
          return currentdate;
        } else {
          currentdate =
            year +
            hengGang +
            month +
            hengGang +
            curDate +
            " " +
            curHours +
            maoHao +
            curMinutes +
            maoHao +
            curSeconds;
          return currentdate;
        }
      },
      view() {
        window.open(
          "https://www.revolvermaps.com/?target=enlarge&i=5tyqnoargc4",
          "blank",
        );
      },
      getMap() {
        const mapDom = document.getElementById("map");
        if (!mapDom) return;
        const rateChart = this.$echarts.init(mapDom);

        const uploadedDataURL = "/world.json";

        fetch(uploadedDataURL)
          .then((res) => res.json())
          .then((geoJson) => {
            this.$echarts.registerMap("world", geoJson);

            const option = {
              series: [
                {
                  type: "map",
                  mapType: "world",
                  roam: false,
                  itemStyle: {
                    areaColor: "#fff",
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                  },
                  emphasis: {
                    label: { show: false },
                  },
                  data: [],
                },
              ],
            };

            rateChart.setOption(option);
            window.addEventListener("resize", () => rateChart.resize());
          })
          .catch((err) => {
            console.error("世界地图json加载失败：", err);
          });

        this.$once("hook:beforeDestroy", () => {
          rateChart?.dispose();
        });
      },
    },
    beforeCreate: function () {
      // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
    },
    created: function () {
      // 实例已经创建完成之后被调用。在这一步，实例已完成以下的配置：数据观测(data observer)，属性和方法的运算， watch/event 事件回调。然而，挂载阶段还没开始，el 属性目前不可见。
    },
    beforeMount: function () {
      // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    },
    beforeUpdate: function () {
      // 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
    },
    updated: function () {
      // 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
      // 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。然而在大多数情况下，你应该避免在此期间更改状态，因为这可能会导致更新无限循环。
      // 该钩子在服务器端渲染期间不被调用。
    },
    beforeDestroy: function () {
      // 实例销毁之前调用。在这一步，实例仍然完全可用。
    },
    destroyed: function () {
      // Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，所有的事件监听器会被移除，所有的子实例也会被销毁。 该钩子在服务器端渲染期间不被调用。
    },
  };
</script>
<style scoped>
  .header {
    height: auto !important;
    background: #637e8f;
    padding: 0 !important;
    margin-bottom: 2%;
    text-align: center;
  }
  .aside {
    background-color: rgb(238, 241, 246);
  }
  .elmain {
    padding: 0;
    overflow: inherit;
    margin: auto;
    width: 70%;
  }

  iframe {
    width: 500px;
    height: 200px;
    /* margin: 0 auto; */
    /* width: 100%; */
    /* margin-left: -20px; */
    pointer-events: none;
  }
  .footer {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto !important;
    /* background: rgba(8, 138, 105, 0.8); */
    /* margin-top: 40px !important; */
    /* margin: 0 auto; */
    align-items: center;
    /* position: relative; */
    background: #637e8e;
    text-align: center;
    margin-top: 1%;
    color: white;
    font-size: 19px;
  }
  .footer a {
    color: white;
    text-decoration: none;
  }
  .footer a:hover {
    color: #f6bc1b;
  }
  .footer iframe {
    width: 200px !important; /* no */
    height: 130px !important; /* no */
    pointer-events: none;
  }
  .map {
    pointer-events: none;
  }
  #map {
    width: 270px;
    height: 150px;
  }
  .map-img {
    margin: 10px 0 -10px 10px;
  }
</style>
